<section class="drive-band band--night" id="night-drive">
  <app-night-drive
    mode="band"
    preset="cruise"
    poster="assets/images/background/background-home.jpg"
    [boostTarget]="cta"
    #nd
  ></app-night-drive>
  <div class="band-night__scrim" aria-hidden="true"></div>
  <div class="container band-content">
    <h2
      class="band-night__title"
      [appSplitText]="('home.welcome.text-1' | translate) + ' ' + ('home.welcome.text-2' | translate)"
      splitMode="reveal"
    ></h2>
    <div class="band-night__actions">
      <a
        #cta
        class="dv-pill dv-pill--light cta-sheen"
        appMagnetic
        [href]="motion.sectionHref('contact')"
        (click)="go($event)"
      >
        <i class="icofont icofont-ui-call dv-ring" aria-hidden="true"></i>
        <span class="magnetic-label">{{ 'home.welcome.contact-btn' | translate }}</span>
      </a>
      <a class="band-night__phone" href="tel:+37441885885">+374 41885885</a>
    </div>
  </div>
</section>
